import React from 'react'

export default function Banner() {
  return (
<section className="breadcrumb-area">
  <div
    className="breadcrumb-widget  breadcrumb-widget-3 pt-200 pb-200"
    style={{ backgroundImage: "url(img/breadcrumb/bg-4.jpg)" }}
  >
    <div className="container">
      <div className="row">
        <div className="col-lg-7 mx-auto">
          <div className="breadcrumb-content pt-100">
            <h1>We're here to help.</h1>
            <ul>
              <li>
                <a href="index-2.html">home</a>
              </li>
              <li>Contact Us</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
  )
}
